export const debug = /edktDebug=true/.test(window.location.href)
  ? // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-console
    (...data: any[]) => console.debug('Edgekit', ...data)
  : // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars
    (..._data: any[]) => {};
